module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/timeline__background@2x-124a05d6b9f50464920545a69056f8cc.png";